<template>
  <div class="payment-description_block">
    <div class="right">
      <h3 class="large_black_label">決済も契約手続きも楽々。</h3>
      <p>支払いはクレジットカードで。</p>
      <p>注文書や請求書もひな型を発行※するので、一から作成する手間を大幅に削減。</p>
      <p class="small_label">※ 契約はオペレーターとクライアントの間で取り交わしていただくので、内容を確認・修正の上ご使用ください。</p>
    </div>
    <div class="left">
      <img class='base_image' src='@/assets/image/pages/top/payment.png'>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PaymentDescriptionBlock",
  }
</script>

<style lang="scss" scoped>
  .payment-description_block {
    @include double_columns(30%, 40%);
    flex-flow: row-reverse;

    > .left > .base_image {
      margin-left: 25%;
      width: 70%;
    }

    @media screen and (max-width: 767px) {
      > .left > .base_image {
        margin: 2rem auto 0 auto;
      }
    }
  }
</style>